/**
 * File Command Group
 * Upload & share HTML and Markdown files
 * j file (top-level command)
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createFileUploadCommand } from './upload.js';
import { createFileUploadDirCommand } from './upload-dir.js';
import { createFileListCommand } from './list.js';
import { createFileDeleteCommand } from './delete.js';
import { createFileOpenCommand } from './open.js';
import { createFileCollectionsCommand } from './collections.js';
import { createFileCollectionShowCommand } from './collection-show.js';
import { createFileQuotaCommand } from './quota.js';

function showFileHelp(): void {
    console.log(chalk.bold.cyan('j file') + chalk.dim(' - Upload & share HTML/Markdown/Image files'));
    console.log();
    console.log(chalk.bold('Commands:'));
    console.log(`  ${chalk.cyan('upload')}        Upload file (HTML/Markdown/Image), get public URL`);
    console.log(`  ${chalk.cyan('upload-dir')}    Upload directory, generate browsable index`);
    console.log(`  ${chalk.cyan('list')}          List uploaded files`);
    console.log(`  ${chalk.cyan('collections')}   List file collections`);
    console.log(`  ${chalk.cyan('collection')}    Show collection detail with file links`);
    console.log(`  ${chalk.cyan('delete')}        Delete uploaded file`);
    console.log(`  ${chalk.cyan('open')}          Open URL in browser`);
    console.log(`  ${chalk.cyan('quota')}         Show upload quota usage`);
    console.log();
    console.log(chalk.bold('Supported formats:'));
    console.log(chalk.dim('  .html, .htm     HTML files'));
    console.log(chalk.dim('  .md, .markdown  Markdown files (auto-converted to HTML)'));
    console.log(chalk.dim('  .png, .jpg, .jpeg, .webp, .gif  Image files'));
    console.log();
    console.log(chalk.bold('Examples:'));
    console.log(chalk.dim('  $ j file upload index.html'));
    console.log(chalk.dim('  $ j file upload README.md --open'));
    console.log(chalk.dim('  $ j file upload-dir ./docs --open'));
    console.log(chalk.dim('  $ j file upload-dir ./build --personal'));
    console.log(chalk.dim('  $ j file collections'));
    console.log(chalk.dim('  $ j file collection 1'));
    console.log(chalk.dim('  $ j file list'));
    console.log(chalk.dim('  $ j file open 42'));
    console.log(chalk.dim('  $ j file quota'));
    console.log();
    console.log(chalk.dim('  All commands support -j / --json'));
    console.log(chalk.dim('  Run "j file <command> --help" for details'));
}

export function createFileCommand(): Command {
    const cmd = new Command('file')
        .description('Upload & share HTML/Markdown/Image files')
        .action(() => {
            showFileHelp();
        });

    cmd.addCommand(createFileUploadCommand());
    cmd.addCommand(createFileUploadDirCommand());
    cmd.addCommand(createFileListCommand());
    cmd.addCommand(createFileCollectionsCommand());
    cmd.addCommand(createFileCollectionShowCommand());
    cmd.addCommand(createFileDeleteCommand());
    cmd.addCommand(createFileOpenCommand());
    cmd.addCommand(createFileQuotaCommand());

    return cmd;
}
